import React from 'react';
import '../template-file-css/document-file-template.css';


export const EYPC_DmaMhsSra = ({
    itemsRef,
    showErrorFor,
}) => {

    return (
        <form id='EYPC_DmaMhsSra' className='file-pdf-document'>
            <div className='file-template'>

                <p className='w-750'><center><h3><b>SERVICE AUTHORIZATION FORM </b></h3>
                    <h4><b>MENTAL HEALTH SKILL-BUILDING (MHSS) H0046 INITIAL <br />
                        Service Authorization Request Form </b></h4></center></p>

                <p className='w-750'><center><h4><b>MEMBER INFORMATION</b></h4></center></p><br />

                <table>
                    <tr>
                        <td className='w-375'>
                            <span className='eleHeader'>Member First Name:</span></td>
                        <td className='w-375'>
                            <span className='eleHeader'>Member Last Name:</span></td>
                    </tr>
                    <tr>
                        <td className='w-375'>
                            <input type='text' id='txtMemberFirstName' name='txtMemberFirstName' className='add-only' /></td>
                        <td className='w-375'>
                            <input type='text' id='txtMemberLastName' name='txtMemberLastName' className='add-only' /></td>
                    </tr>
                    <tr>
                        <td className='w-250'>
                            <span className='eleHeader'>Medicaid #:</span></td>
                        <td className='w-250'>
                            <span className='eleHeader'>Member Date of Birth:</span></td>
                        <td className='w-250'>
                            <span className='eleHeader'>Gender:</span></td>
                    </tr>
                    <tr>
                        <td className='w-250'>
                            <input type='text' id='txtMedicaid' name='txtMedicaid' className='add-only' /></td>
                        <td className='w-250'>
                            <input type='date' id='txtMemberDateOfBirth' name='txtMemberDateOfBirth' className='add-only' /></td>
                        <td className='w-250'>
                            <input type='radio' id='rbGender_Male' name='rbGender' className='add-only' value='Male' /> Male&nbsp;
                            <input type='radio' id='rbGender_Female' name='rbGender' className='add-only' value='Female' /> Female&nbsp;
                            <input type='radio' id='rbGender_Other' name='rbGender' className='add-only' value='Other' /> Other</td>
                    </tr>

                    <tr>
                        <td className='w-375'>
                            <span className='eleHeader'>Member Plan ID #:</span></td>
                        <td className='w-375'>
                            <span className='eleHeader'>Member Street Address:</span></td>
                    </tr>
                    <tr>
                        <td className='w-375'>
                            <input type='text' id='txtMemberPlanId' name='txtMemberPlanId' className='add-only' /></td>
                        <td className='w-375'>
                            <input type='text' id='txtMemberStreetAddress' name='txtMemberStreetAddress' className='add-only' /></td>
                    </tr>

                    <tr>
                        <td className='w-250'>
                            <span className='eleHeader'>City:</span></td>
                        <td className='w-250'>
                            <span className='eleHeader'>State:</span></td>
                        <td className='w-250'>
                            <span className='eleHeader'>Zip:</span></td>

                    </tr>
                    <tr>
                        <td className='w-250'>
                            <input type='text' id='txtCity' name='txtCity' className='add-only' /></td>
                        <td className='w-250'>
                            <input type='text' id='txtState' name='txtState' className='add-only' /></td>
                        <td className='w-250'>
                            <input type='text' id='txtZip' name='txtZip' className='add-only' /></td>
                    </tr>

                    <tr>
                        <td className='w-375'>
                            <span className='eleHeader'>Parent/Guardian (if applicable):</span></td>
                        <td className='w-375'>
                            <span className='eleHeader'>Parent/Guardian (if applicable) Contact Information: </span></td>
                    </tr>
                    <tr>
                        <td className='w-375'>
                            <input type='text' id='txtParentGuardian' name='txtParentGuardian' className='add-only' /></td>
                        <td className='w-375'>
                            <input type='text' id='txtParentGuardianContactInformation' name='txtParentGuardianContactInformation' className='add-only' /></td>
                    </tr>

                </table>


                <p className='w-750'><center><h4><b>PROVIDER INFORMATION</b></h4></center></p><br />

                <table>
                    <tr>
                        <td className='w-375'>
                            <span className='eleHeader'>Organization Name:</span></td>
                        <td className='w-375'>
                            <span className='eleHeader'>Group NPI #:</span></td>
                    </tr>
                    <tr>
                        <td className='w-375'>
                            <input type='text' id='txtOrganizationName' name='txtOrganizationName' placeholder='Empowering Youth for Positive Change' className='add-only' /></td>
                        <td className='w-375'>
                            <input type='text' id='txtGroupNpi' name='txtGroupNpi' defaultValue={1538446679} className='add-only' /></td>
                    </tr>
                    <tr>
                        <td className='w-375'>
                            <span className='eleHeader'>Provider Tax ID #:</span></td>
                        <td className='w-375'>
                            <span className='eleHeader'>Provider Phone:</span></td>

                    </tr>
                    <tr>
                        <td className='w-375'>
                            <input type='text' id='txtProviderTax' name='txtProviderTax' defaultValue={473114954} className='add-only' /></td>
                        <td className='w-375'>
                            <input type='text' id='txtProviderPhone' name='txtProviderPhone' defaultValue={8047891314} className='add-only' /></td>

                    </tr>

                    <tr>
                        <td className='w-250'>
                            <span className='eleHeader'>Provider E-Mail:</span></td>
                        <td className='w-250'>
                            <span className='eleHeader'>Provider Address:</span></td>
                        <td className='w-250'>
                            <span className='eleHeader'>Provider Fax:</span></td>
                    </tr>
                    <tr>
                        <td className='w-250'>
                            <input type='text' id='txtProviderEmail' name='txtProviderEmail' className='add-only' /></td>
                        <td className='w-250'>
                            <input type='text' id='txtProviderAddress' name='txtProviderAddress' placeholder='101 Cowardin Avenue' className='add-only' /></td>
                        <td className='w-250'>
                            <input type='text' id='txtProviderFax' name='txtProviderFax' placeholder='8044823767' className='add-only' /></td>
                    </tr>

                    <tr>
                        <td className='w-250'>
                            <span className='eleHeader'>City:</span></td>
                        <td className='w-250'>
                            <span className='eleHeader'>State:</span></td>
                        <td className='w-250'>
                            <span className='eleHeader'>Zip:</span></td>

                    </tr>
                    <tr>
                        <td className='w-250'>
                            <input type='text' id='txtCity_1' name='txtCity_1' className='add-only' /></td>
                        <td className='w-250'>
                            <input type='text' id='txtState_1' name='txtState_1' className='add-only' /></td>
                        <td className='w-250'>
                            <input type='text' id='txtZip_1' name='txtZip_1' className='add-only' /></td>
                    </tr>

                    <tr>
                        <td className='w-375'>
                            <span className='eleHeader'>Clinical Contact Name & Credentials*:</span></td>
                        <td className='w-375'>
                            <span className='eleHeader'>Clinical Contact Phone:</span></td>
                    </tr>
                    <tr>
                        <td className='w-375'>
                            <input type='text' id='txtClinicalContactName' name='txtClinicalContactName' className='add-only' /></td>
                        <td className='w-375'>
                            <input type='text' id='txtClinicalContactPhone' name='txtClinicalContactPhone' className='add-only' /></td>
                    </tr>
                </table>

                <p className='w-750'><b>* This is the individual to whom the MCO can reach out
                    to answer additional clinical questions</b></p>

                <p className='w-750'><span className='eleHeader'>Request for approval of services:</span>
                    From&nbsp;
                    <input type='date' id='txtRequestForApprovalServices_1' name='txtRequestForApprovalServices_1' className='add-only w-150 custom-add-only' /> (date), To&nbsp;
                    &nbsp;<input type='date' id='txtRequestForApprovalServices_2' name='txtRequestForApprovalServices_2' className='add-only w-150 custom-add-only' /> (date), for a total of&nbsp;
                    &nbsp;<input type='text' id='txtRequestForApprovalServices_3' name='txtRequestForApprovalServices_3' className='add-only w-150 custom-add-only' /> units of service.&nbsp;
                    Plan to provide
                    &nbsp;<input type='text' id='txtRequestForApprovalServices_4' name='txtRequestForApprovalServices_4' className='add-only w-150 custom-add-only' /> hours of service per week.
                    <br />

                    <span className='eleHeader'>Retro Review Request?</span>
                    <input type='radio' id='rbRetroReviewRequest_Yes' name='rbRetroReviewRequest' className='add-only' value='Yes' /> Yes &nbsp;
                    <input type='radio' id='rbRetroReviewRequest_No' name='rbRetroReviewRequest' className='add-only' value='No' /> No
                    <br />

                    <span className='eleHeader'>Is this a new service for the member?</span>
                    <input type='radio' id='rbIsThisNewServiceForTheMember_Yes' name='rbIsThisNewServiceForTheMember' className='add-only' value='Yes' /> Yes &nbsp;
                    <input type='radio' id='rbIsThisNewServiceForTheMember_No' name='rbIsThisNewServiceForTheMember' className='add-only' value='No' /> No
                    <br />

                    <b>(If no, then complete an authorization for continuing care.)</b>
                    <br />

                    <span className='eleHeader'>Primary ICD-10 Diagnosis</span>
                    <input type='text' id='txtPrimaryDiagnosis' name='txtPrimaryDiagnosis' className='add-only' /> <br />

                    <span className='eleHeader'>Secondary Diagnosis(es)</span>
                    <input type='text' id='txtSecondaryDiagnosis' name='txtSecondaryDiagnosis' className='add-only' /> <br /><br />
                </p>

                <p className='w-750'><center><h4><b>SECTION I: MENTAL HEALTH SKILL-BUILDING ELIGIBILITY CRITERIA</b></h4></center>
                    <span className='eleHeader'>Individuals qualifying for Mental Health Skill Building Services (MHSS) must demonstrate a
                        clinical necessity for the service arising from a condition due to mental, behavioral, or
                        emotional illness that results in significant functional impairments in major life activities.
                        Services are provided to individuals who require individualized training to achieve or maintain
                        stability and independence in the community.</span>
                    <input type='radio' id='rbIndividualsQualifyingForMentalHealthSkill_Yes' name='rbIndividualsQualifyingForMentalHealthSkill' className='add-only' value='Yes' /> Yes &nbsp;
                    <input type='radio' id='rbIndividualsQualifyingForMentalHealthSkill_No' name='rbIndividualsQualifyingForMentalHealthSkill' className='add-only' value='No' /> No
                    <br />

                    <span className='eleHeader'>Please describe member's current functional impairments:</span>
                    <textarea id='txtPleaseDescribeMemberCurrent' name='txtPleaseDescribeMemberCurrent' className='add-only'></textarea><br />

                    <span className='eleHeader'>Please describe why MHSS services are required for member to achieve or maintain stability
                        and independence in the community (Ex: recent increase in symptoms/decrease in functioning?
                        Transitioning to an independent living setting? Current risk of homelessness or
                        hospitalization?):</span>
                    <textarea id='txtPleaseDescribeServicesAreRequiredMember' name='txtPleaseDescribeServicesAreRequiredMember' className='add-only'></textarea>
                    <br />

                    <span className='eleHeader'>The individual shall have one of the following as a primary diagnosis:</span>
                    <input type='radio' id='rbTheIndividualShallHaveOne_Yes' name='rbTheIndividualShallHaveOne' className='add-only' value='Yes' /> Yes &nbsp;
                    <input type='radio' id='rbTheIndividualShallHaveOne_No' name='rbTheIndividualShallHaveOne' className='add-only' value='No' /> No</p>

                <p className='w-750'>
                    <ol>
                        <li>Schizophrenia or other psychotic disorder as set out in the DSM</li>
                        <li>Major Depressive Disorder — Recurrent</li>
                        <li>Bipolar I or Bipolar II</li>
                        <li>Any other DSM mental health disorder that a physician has documented specific to the
                            identified individual within the past year to include all the following:

                            <ol type='i'>
                                <li>that is a serious mental illness;</li>
                                <li>that results in severe and recurrent disability;</li>
                                <li>that produces functional limitations in the individual's major life activities that
                                    are documented in the individual's medical record, and;</li>
                                <li>that the individual requires individualized training to achieve or maintain
                                    independent living in the community</li>
                            </ol></li>
                    </ol>
                </p>


                <p className='w-750'>
                    <span className='eleHeader'>The individual requires training in acquiring basic living skills such as symptom management; adherence to psychiatric and medication treatment plans; development and appropriate use of social skills and personal support system; personal hygiene; food preparation; or money management.</span>
                    <input type='radio' id='rbTheIndividualRequiresTrainingIn_Yes' name='rbTheIndividualRequiresTrainingIn' className='add-only' value='Yes' /> Yes &nbsp;
                    <input type='radio' id='rbTheIndividualRequiresTrainingIn_No' name='rbTheIndividualRequiresTrainingIn' className='add-only' value='No' /> No

                    <br />
                    <span className='eleHeader'>Please describe member's current skill level and abilities - be specific to track progress or lack
                        of progress: (Provide examples; Identify - frequency, severity, and duration of each behavior)</span>
                    <textarea id='txtPleaseDescribeMemberCurrent' name='txtPleaseDescribeMemberCurrent' className='add-only'></textarea> <br />

                    <span className='eleHeader'>Prior to starting MHSS services the individual has been determined to have a prior history of
                        psychiatric hospitalization, residential crisis stabilization, ICT or Program of Assertive
                        Community Treatment (PACT) services, placement in a psychiatric residential treatment facility,
                        or Temporary Detention Order because of decompensation related to serious mental illness.</span>
                    <input type='radio' id='rbPriorToStartingServicesTheIndividual_Yes' name='rbPriorToStartingServicesTheIndividual' className='add-only' value='Yes' /> Yes &nbsp;
                    <input type='radio' id='rbPriorToStartingServicesTheIndividual_No' name='rbPriorToStartingServicesTheIndividual' className='add-only' value='No' /> No</p>

                <table>
                    <tr>
                        <td className='w-250'>
                            <span className='eleHeader'>Name of Service</span></td>
                        <td className='w-150'>
                            <span className='eleHeader'>Date of Service </span></td>
                        <td className='w-350'>
                            <span className='eleHeader'>Reason for Admission</span></td>
                    </tr>
                    <tr>
                        <td className='w-250'>
                            <input type='text' id='txtNameOfSevice_1' name='txtNameOfSevice_1' className='add-only' /></td>
                        <td className='w-150'>
                            <input type='date' id='txtDateOfSevice_1' name='txtDateOfSevice_1' className='add-only' /></td>
                        <td className='w-350'>
                            <input type='text' id='txtReasonForAdmission_1' name='txtReasonForAdmission_1' className='add-only' /></td>
                    </tr>
                    <tr>
                        <td className='w-250'>
                            <input type='text' id='txtNameOfSevice_2' name='txtNameOfSevice_2' className='add-only' /></td>
                        <td className='w-150'>
                            <input type='date' id='txtDateOfSevice_2' name='txtDateOfSevice_2' className='add-only' /></td>
                        <td className='w-350'>
                            <input type='text' id='txtReasonForAdmission_2' name='txtReasonForAdmission_2' className='add-only' /></td>
                    </tr>
                    <tr>
                        <td className='w-250'>
                            <input type='text' id='txtNameOfSevice_3' name='txtNameOfSevice_3' className='add-only' /></td>
                        <td className='w-150'>
                            <input type='date' id='txtDateOfSevice_3' name='txtDateOfSevice_3' className='add-only' /></td>
                        <td className='w-350'>
                            <input type='text' id='txtReasonForAdmission_3' name='txtReasonForAdmission_3' className='add-only' /></td>
                    </tr>
                    <tr>
                        <td className='w-250'>
                            <input type='text' id='txtNameOfSevice_4' name='txtNameOfSevice_4' className='add-only' /></td>
                        <td className='w-150'>
                            <input type='date' id='txtDateOfSevice_4' name='txtDateOfSevice_4' className='add-only' /></td>
                        <td className='w-350'>
                            <input type='text' id='txtReasonForAdmission_4' name='txtReasonForAdmission_4' className='add-only' /></td>
                    </tr>
                </table>

                <p className='w-750'> <span className='eleHeader'>Prior to starting MHSS services the individual has a prescription for anti-psychotic, mood
                    stabilizing, or antidepressant medications within 12 months prior to the assessment date
                    unless there is signed documentation from a physician or other licensed prescribing
                    practitioner indicating that medications are contraindicated.</span>
                    <input type='radio' id='rbPriorToStartingTheIndividual_Yes' name='rbPriorToStartingTheIndividual' className='add-only' value='Yes' /> Yes &nbsp;
                    <input type='radio' id='rbPriorToStartingTheIndividual_No' name='rbPriorToStartingTheIndividual' className='add-only' value='No' /> No</p>

                <table>
                    <tr>
                        <td className='w-350'>
                            <span className='eleHeader'>Name of Medication</span></td>
                        <td className='w-150'>
                            <span className='eleHeader'>Dosage </span></td>
                        <td className='w-250'>
                            <span className='eleHeader'>Frequency</span></td>
                    </tr>
                    <tr>
                        <td className='w-350'>
                            <input type='text' id='txtNameOfMedication_1' name='txtNameOfMedication_1' className='add-only' /></td>
                        <td className='w-150'>
                            <input type='text' id='txtDosage_1' name='txtDosage_1' className='add-only' /></td>
                        <td className='w-250'>
                            <input type='text' id='txtFrequency_1' name='txtFrequency_1' className='add-only' /></td>
                    </tr>
                    <tr>
                        <td className='w-350'>
                            <input type='text' id='txtNameOfMedication_2' name='txtNameOfMedication_2' className='add-only' /></td>
                        <td className='w-150'>
                            <input type='text' id='txtDosage_2' name='txtDosage_2' className='add-only' /></td>
                        <td className='w-250'>
                            <input type='text' id='txtFrequency_2' name='txtFrequency_2' className='add-only' /></td>
                    </tr>
                    <tr>
                        <td className='w-350'>
                            <input type='text' id='txtNameOfMedication_3' name='txtNameOfMedication_3' className='add-only' /></td>
                        <td className='w-150'>
                            <input type='text' id='txtDosage_3' name='txtDosage_3' className='add-only' /></td>
                        <td className='w-250'>
                            <input type='text' id='txtFrequency_3' name='txtFrequency_3' className='add-only' /></td>
                    </tr>
                    <tr>
                        <td className='w-350'>
                            <input type='text' id='txtNameOfMedication_4' name='txtNameOfMedication_4' className='add-only' /></td>
                        <td className='w-150'>
                            <input type='text' id='txtDosage_4' name='txtDosage_4' className='add-only' /></td>
                        <td className='w-250'>
                            <input type='text' id='txtFrequency_4' name='txtFrequency_4' className='add-only' /></td>
                    </tr>
                </table>

                <p className='w-750'>
                    <input type='checkbox' id='cbNoPsychotropicMedications' name='cbNoPsychotropicMedications' className='add-only' value='1' />
                    No psychotropic medications prescribed, documentation of contraindication is attached
                    <br />
                    <span className='eleHeader'>** If under 21 years old — Member is in an independent living situation or actively transitioning
                        into an independent living situation (not living with a parent or guardian or in a supervised
                        setting and providing own financial support).</span>
                    <input type='radio' id='rbIfUnderYearsOldMemberIndependent_Yes' name='rbIfUnderYearsOldMemberIndependent' className='add-only' value='Yes' /> Yes &nbsp;
                    <input type='radio' id='rbIfUnderYearsOldMemberIndependent_No' name='rbIfUnderYearsOldMemberIndependent' className='add-only' value='No' /> No&nbsp;
                    <input type='radio' id='rbIfUnderYearsOldMemberIndependent_Na' name='rbIfUnderYearsOldMemberIndependent' className='add-only' value='Na' /> N/A</p>


                <p className='w-750'><center><h4><b>SECTION II: CARE COORDINATION</b></h4></center>
                    <span className='eleHeader'>Primary Care Physician:</span>
                    <input type='text' id='txtPrimaryCarePhysician' name='txtPrimaryCarePhysician' className='add-only' />

                    <span className='eleHeader'>Other medical/behavioral health concerns (including substance abuse issues, personality disorders, dementia,
                        cognitive impairments) that could impact services?</span>
                    <input type='radio' id='rbOtherMedicalBehavioralHealth_Yes' name='rbOtherMedicalBehavioralHealth' className='add-only' value='Yes' /> Yes &nbsp;
                    <input type='radio' id='rbOtherMedicalBehavioralHealth_No' name='rbOtherMedicalBehavioralHealth' className='add-only' value='No' /> No
                    <br />

                    <b> (If yes, explain below.)</b><br />
                    <textarea id='txtIfYesExplainBelow' name='txtIfYesExplainBelow' className='add-only'></textarea>
                    <br />
                    <b>Please indicate other medical/behavioral services and additional community supports/interventions received:</b></p>

                <table>
                    <tr>
                        <td className='w-350'>
                            <span className='eleHeader'>Name of service/treatment <br />&nbsp;</span></td>
                        <td className='w-150'>
                            <span className='eleHeader'>Provider/Contact Information</span></td>
                        <td className='w-250'>
                            <span className='eleHeader'>Frequency <br />&nbsp;</span></td>
                    </tr>
                    <tr>
                        <td className='w-350'>
                            <input type='text' id='txtNameOfServiceTreatment_1' name='txtNameOfServiceTreatment_1' className='add-only' /></td>
                        <td className='w-150'>
                            <input type='text' id='txtProviderContactInformation_1' name='txtProviderContactInformation_1' className='add-only' /></td>
                        <td className='w-250'>
                            <input type='text' id='txtFrequency_5' name='txtFrequency_5' className='add-only' /></td>
                    </tr>
                    <tr>
                        <td className='w-350'>
                            <input type='text' id='txtNameOfServiceTreatment_2' name='txtNameOfServiceTreatment_2' className='add-only' /></td>
                        <td className='w-150'>
                            <input type='text' id='txtProviderContactInformation_2' name='txtProviderContactInformation_2' className='add-only' /></td>
                        <td className='w-250'>
                            <input type='text' id='txtFrequency_6' name='txtFrequency_6' className='add-only' /></td>
                    </tr>
                    <tr>
                        <td className='w-350'>
                            <input type='text' id='txtNameOfServiceTreatment_3' name='txtNameOfServiceTreatment_3' className='add-only' /></td>
                        <td className='w-150'>
                            <input type='text' id='txtProviderContactInformation_3' name='txtProviderContactInformation_3' className='add-only' /></td>
                        <td className='w-250'>
                            <input type='text' id='txtFrequency_7' name='txtFrequency_7' className='add-only' /></td>
                    </tr>
                    <tr>
                        <td className='w-350'>
                            <input type='text' id='txtNameOfServiceTreatment_4' name='txtNameOfServiceTreatment_4' className='add-only' /></td>
                        <td className='w-150'>
                            <input type='text' id='txtProviderContactInformation_4' name='txtProviderContactInformation_4' className='add-only' /></td>
                        <td className='w-250'>
                            <input type='text' id='txtFrequency_8' name='txtFrequency_8' className='add-only' /></td>
                    </tr>
                </table>

                <p className='w-750'><span className='eleHeader'>Indicate plan to coordinate with primary care physician and other treatment providers/services to help ensure
                    treatment interventions are coordinated:</span>
                    <textarea id='txtIndicatePlanCoordinateWithPrimary' name='txtIndicatePlanCoordinateWithPrimary' className='add-only'></textarea>
                    <br />

                    <span className='eleHeader'>Does the member currently have any services in place to assist with daily living skills, social skills,
                        socialization, medication management, and money management? (Ex: Assisted living or group home staff,
                        Psychosocial Rehabilitation, payee services, supportive friends or family). Please list any current services
                        being provided to this member as described above:</span>
                    <textarea id='txtDoesTheMemberCurrently' name='txtDoesTheMemberCurrently' className='add-only'></textarea> <br />

                    <span className='eleHeader'>If services are in place for this member, please clarify how additional Mental Health Skill-Building Services are
                        necessary and will not duplicate the services member is currently receiving:</span>
                    <textarea id='txtIfServicesAreInPlaceForThis' name='txtIfServicesAreInPlaceForThis' className='add-only'></textarea>
                </p>

                <p className='w-750'><center><h4><b>SECTION III: TRAUMA-INFORMED CARE</b></h4></center>
                    <b>Trauma-Informed Care</b>(Many individuals have experienced potentially traumatic events in their lifetime. It is important
                    that everyone is aware of the potential impact of trauma on those they serve, prepare to recognize and offer traumaspecific services when needed, and be mindful of trauma-informed interventions.)
                    <br />

                    <span className='eleHeader'>Is there evidence to suggest this member has experienced trauma?</span>
                    <input type='radio' id='rbIsThereEvidenceToSuggestThis_Yes' name='rbIsThereEvidenceToSuggestThis' className='add-only' value='Yes' /> Yes &nbsp;
                    <input type='radio' id='rbIsThereEvidenceToSuggestThis_No' name='rbIsThereEvidenceToSuggestThis' className='add-only' value='No' /> No
                    <br />

                    <span className='eleHeader'>What is your plan to assess/refer and address the current and potential effects of that trauma?</span>
                    <textarea id='txtWhatIsYourPlanToAssess' name='txtWhatIsYourPlanToAssess' className='add-only'></textarea></p>



                <p className='w-750'><center><h4><b>SECTION IV: INDIVIDUAL TREATMENT GOALS</b></h4></center>
                    <b>Treatment Goals/Progress:</b> <br />
                    <ul>
                        <li>Describe person-centered, recovery-oriented, trauma-informed mental health treatment goals as they relate to
                            requested treatment. Include individual strengths/barriers/gaps in service, and written in own words of individual
                            seeking treatment/or in a manner that is understood by individual seeking treatment. If individual has identified a
                            history of trauma, please include trauma-informed care interventions or referral in the treatment plan</li>
                        <li>Services are intended to include goal directed training/interventions that will enable individuals to learn the skills
                            necessary to achieve or maintain stability in the least restrictive environment. Providers should demonstrate efforts
                            to assist the individual in progressing toward goals to achieve their maximum potential.</li>
                        <li>Please demonstrate that the individual is benefiting from the service as evidenced by objective progress toward
                            goals or modifications and updates that are being made to the treatment plan to address areas with lack of
                            progress</li>
                        <li>Include any appointments and medications adherence issues and plans to address this, if applicable.</li>
                    </ul>
                </p>


                <p className='w-750'>
                    <span className='eleHeader'><b>Resources and Strengths:</b>Document individual's strengths, preferences, extracurricular/community/social activities
                        and people the individual identifies as supports</span>
                    <textarea id='txtResourcesAndStrengths' name='txtResourcesAndStrengths' className='add-only'></textarea> <br />

                    <span className='eleHeader'>Please describe any barriers to treatment:</span>
                    <textarea id='txtPleaseDescribeAnyBarriers' name='txtPleaseDescribeAnyBarriers' className='add-only'></textarea> <br />

                    <span className='eleHeader'><b>Goal/Objective </b>(Please provide objective measures to demonstrate evidence of progress. Measurable objectives
                        should have meaningful tracking values; avoid percentages unless able to track and measure percent completion i.e. if
                        80%, state 8 of 10 as a more trackable value):</span>
                    <textarea id='txtGoalObjective_1' name='txtGoalObjective_1' className='add-only'></textarea> <br />

                    <span className='eleHeader'>Please describe where the member is now regarding this specific objective.</span>
                    <textarea id='txtPleaseDescribeRegarding_1' name='txtPleaseDescribeRegarding_1' className='add-only'></textarea><br />

                    <span className='eleHeader'>How many days per week will be spent addressing this goal on average?</span>
                    <input type='text' id='txtHowManyDaysPer_1' name='txtHowManyDaysPer_1' className='add-only' /><br />

                    <span className='eleHeader'>What specific training and interventions will be provided to address this goal?</span>
                    <textarea id='txtWhatSpecificTrainingAndInterventions_1' name='txtWhatSpecificTrainingAndInterventions_1' className='add-only'></textarea><br />

                    <span className='eleHeader'>How will you measure progress on the training or interventions provided?</span>
                    <textarea id='txtHowWillYouMeasureProgressOnThe_1' name='txtHowWillYouMeasureProgressOnThe_1' className='add-only'></textarea><br />

                    <span className='eleHeader'><b>Goal/Objective </b>(Please provide objective measures to demonstrate evidence of progress. Measurable objectives
                        should have meaningful tracking values; avoid percentages unless able to track and measure percent completion i.e. if
                        80%, state 8 of 10 as a more trackable value):</span>
                    <textarea id='txtGoalObjective_2' name='txtGoalObjective_2' className='add-only'></textarea> <br />

                    <span className='eleHeader'>Please describe where the member is now regarding this specific objective.</span>
                    <textarea id='txtPleaseDescribeRegarding_2' name='txtPleaseDescribeRegarding_2' className='add-only'></textarea><br />

                    <span className='eleHeader'>How many days per week will be spent addressing this goal on average?</span>
                    <input type='text' id='txtHowManyDaysPer_2' name='txtHowManyDaysPer_2' className='add-only' /><br />

                    <span className='eleHeader'>What specific training and interventions will be provided to address this goal?</span>
                    <textarea id='txtWhatSpecificTrainingAndInterventions_2' name='txtWhatSpecificTrainingAndInterventions_2' className='add-only'></textarea><br />

                    <span className='eleHeader'>How will you measure progress on the training or interventions provided?</span>
                    <textarea id='txtHowWillYouMeasureProgressOnThe_2' name='txtHowWillYouMeasureProgressOnThe_2' className='add-only'></textarea><br />

                    <span className='eleHeader'><b>Goal/Objective </b>(Please provide objective measures to demonstrate evidence of progress. Measurable objectives
                        should have meaningful tracking values; avoid percentages unless able to track and measure percent completion i.e. if
                        80%, state 8 of 10 as a more trackable value):</span>
                    <textarea id='txtGoalObjective_3' name='txtGoalObjective_3' className='add-only'></textarea> <br />

                    <span className='eleHeader'>Please describe where the member is now regarding this specific objective.</span>
                    <textarea id='txtPleaseDescribeRegarding_3' name='txtPleaseDescribeRegarding_3' className='add-only'></textarea><br />

                    <span className='eleHeader'>How many days per week will be spent addressing this goal on average?</span>
                    <input type='text' id='txtHowManyDaysPer_3' name='txtHowManyDaysPer_3' className='add-only' /><br />

                    <span className='eleHeader'>What specific training and interventions will be provided to address this goal?</span>
                    <textarea id='txtWhatSpecificTrainingAndInterventions_3' name='txtWhatSpecificTrainingAndInterventions_3' className='add-only'></textarea><br />

                    <span className='eleHeader'>How will you measure progress on the training or interventions provided?</span>
                    <textarea id='txtHowWillYouMeasureProgressOnThe_3' name='txtHowWillYouMeasureProgressOnThe_3' className='add-only'></textarea><br />
                </p>


                <p className='w-750'><center><h4><b>SECTION V: DISCHARGE PLANNING</b></h4></center>
                    <b>DISCHARGE PLAN</b>(Identify lower levels of care, natural supports, warm-hand off, care coordination needs)</p>


                <table>
                    <tr>
                        <td className='w-250'>
                            <span className='eleHeader'>Step Down Service/Supports</span></td>
                        <td className='w-250'>
                            <span className='eleHeader'>Identified Provider/Supports</span></td>
                        <td className='w-250'>
                            <span className='eleHeader'>Plan to assist in transition</span></td>
                    </tr>
                    <tr>
                        <td className='w-250'>
                            <input type='text' id='txtStepDownServiceSupports_1' name='txtStepDownServiceSupports_1' className='add-only' /></td>
                        <td className='w-250'>
                            <input type='text' id='txtIdentifiedProviderSupports_1' name='txtIdentifiedProviderSupports_1' className='add-only' /></td>
                        <td className='w-250'>
                            <input type='text' id='txtPlanToAssistInTransition_1' name='txtPlanToAssistInTransition_1' className='add-only' /></td>
                    </tr>
                    <tr>
                        <td className='w-250'>
                            <input type='text' id='txtStepDownServiceSupports_2' name='txtStepDownServiceSupports_2' className='add-only' /></td>
                        <td className='w-250'>
                            <input type='text' id='txtIdentifiedProviderSupports_2' name='txtIdentifiedProviderSupports_2' className='add-only' /></td>
                        <td className='w-250'>
                            <input type='text' id='txtPlanToAssistInTransition_2' name='txtPlanToAssistInTransition_2' className='add-only' /></td>
                    </tr>
                    <tr>
                        <td className='w-250'>
                            <input type='text' id='txtStepDownServiceSupports_3' name='txtStepDownServiceSupports_3' className='add-only' /></td>
                        <td className='w-250'>
                            <input type='text' id='txtIdentifiedProviderSupports_3' name='txtIdentifiedProviderSupports_3' className='add-only' /></td>
                        <td className='w-250'>
                            <input type='text' id='txtPlanToAssistInTransition_3' name='txtPlanToAssistInTransition_3' className='add-only' /></td>
                    </tr>

                </table>

                <p className='w-750'><span className='eleHeader'>Recommended level of care at discharge:</span>
                    <textarea id='txtRecommendedLevelCareDischarge' name='txtRecommendedLevelCareDischarge' className='add-only'></textarea><br />

                    Estimated date of discharge:
                    <input type='date' id='txtEstimatedDate' name='txtEstimatedDate' className='add-only w-200 custom-add-only' />
                    <br />

                    <span className='eleHeader'>
                        The appropriate assessment or addendum has been completed by an LMHP, LMHP-R, LMHP-S, or LMHP-RP and
                        the individual's psychiatric history information reviewed. By my signature (below) I am attesting that the individual
                        meets the medical necessity criteria for the identified service. The assessment or applicable addendum for this
                    </span>
                    <input type='text' id='txtTheAppropriateAddendumHasBeen' name='txtTheAppropriateAddendumHasBeen' className='add-only' />
                </p>

                <table>
                    <tr>
                        <td className='signature w-750'>&nbsp; </td>
                    </tr>
                    <tr>
                        <td className='small w-750'>Signature (actual or electronic) of LMHP (Or R/S/RP):</td>
                    </tr>

                    <tr>
                        <td className='w-350'>
                            <span className='eleHeader'>Printed name of LMHP (Or R/S/RP):</span></td>
                        <td className='w-250'>
                            <span className='eleHeader'>Credentials:</span></td>
                        <td className='w-150'>
                            <span className='eleHeader'>Date</span></td>
                    </tr>
                    <tr>
                        <td className='w-350'>
                            <input type='text' id='txtPrintedName' name='txtPrintedName' className='add-only' /></td>
                        <td className='w-250'>
                            <input type='text' id='txtCredentials' name='txtCredentials' className='add-only' /></td>
                        <td className='w-150'>
                            <input type='date' id='txtDate' name='txtDate' className='add-only' /></td>
                    </tr>
                </table>

                <p className='w-750'><span className='eleHeader'>
                    If any additional CMHRS services were recommended by the assessment or addendum referenced above, please identify the
                    services here:</span>
                    <textarea id='txtIfAnyAdditionalServicesWereRecommended' name='txtIfAnyAdditionalServicesWereRecommended' className='add-only'></textarea><br />

                    <center><h4><b>NOTES SECTION</b></h4></center>
                    <b>If needed, use this page for any answer too long to fit within the form's provided spaces. Please note which
                        section you are continuing before each answer. </b><br />
                    <textarea id='txtIfNeededUseThisPageForAny' name='txtIfNeededUseThisPageForAny' className='add-only'></textarea></p>










            </div >
        </form >

    )
}











